import { useState, useEffect } from 'react';
import { X, Download } from 'lucide-react';

const DISMISS_KEY = 'humaclub_pwa_dismiss';
const DISMISS_DAYS = 7;

export default function InstallPWA() {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if dismissed recently
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed && Date.now() - parseInt(dismissed) < DISMISS_DAYS * 86400000) return;

    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!prompt) return;
    prompt.prompt();
    const result = await prompt.userChoice;
    if (result.outcome === 'accepted') setShow(false);
    setPrompt(null);
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-16 lg:bottom-4 left-4 right-4 z-50 mx-auto max-w-md" data-testid="install-pwa-banner">
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-3 flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-[#7C3AED] to-[#2563EB] flex items-center justify-center text-white font-bold text-sm shrink-0">HC</div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-[#111827]">Install HumaClub</p>
          <p className="text-xs text-gray-500">Get the best experience</p>
        </div>
        <button onClick={handleInstall} className="px-3 py-1.5 rounded-full bg-[#7C3AED] text-white text-xs font-medium hover:bg-[#6D28D9] flex items-center gap-1 shrink-0" data-testid="install-pwa-btn">
          <Download className="w-3 h-3" /> Install
        </button>
        <button onClick={handleDismiss} className="w-7 h-7 rounded-full flex items-center justify-center hover:bg-gray-100 shrink-0" data-testid="dismiss-pwa-btn">
          <X className="w-3.5 h-3.5 text-gray-400" />
        </button>
      </div>
    </div>
  );
}
